/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Input, Inject } from '@angular/core';
import { DeviceHealthCheckLiveChatService } from '../../services';
import { IDeviceHealthCheckLiveChatParams } from '../../models';
import { IUserSettings } from '../../../core/models';
import { environment } from '../../../../environments/environment';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'fm-device-health-check-contact-support',
  templateUrl: './device-health-check-contact-support.component.html',
  styleUrls: ['./device-health-check-contact-support.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeviceHealthCheckContactSupportComponent {
  @Input()
  liveChatParams: IDeviceHealthCheckLiveChatParams;
  @Input()
  userSettings: IUserSettings;

  chatLoading$ = new BehaviorSubject(false);

  constructor(
    @Inject(DOCUMENT) private readonly _document: Document,
    private readonly _deviceHealthCheckLiveChatService: DeviceHealthCheckLiveChatService
  ) {}

  public openContactUs(): void {
    const userLanguage = this.userSettings?.Language ?? this._document.defaultView?.navigator?.language ?? 'en-US';
    const contactUsUrl = `${environment.config.legacyBaseUrl}/${userLanguage}/myaccount-live/contact-us`;
    this._document.defaultView?.open(contactUsUrl, '_blank');
  }

  public openLiveChat(): void {
    this._deviceHealthCheckLiveChatService.openChat(this.liveChatParams);
    this.chatLoading$.next(true);
    setTimeout(() => {
      this.chatLoading$.next(false);
    }, this._deviceHealthCheckLiveChatService.showChatDelay);
  }
}
